import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/_services/language.service';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.css']
})
export class PortalComponent implements OnInit {

  public breadcrumb: any;
  currentOrientation = 'horizontal';
  start: any;
  end: any;

  constructor(private i18nService: LanguageService,
    private translateService: TranslateService) { }

  ngOnInit() {
    this.breadcrumb = {
      'mainlabel': 'Egresados'
    };

  }

}
